import EnumObject from '../../enum-object.entity';

export default class ContractList {
  id: string;

  code: string;

  status: EnumObject;

  currentVersion: number;

  versionDate: string;

  startedAt: string;

  concludedAt: string;

  instancesAmount: number;

  customerName: string;

  customerDocument: string;

  businessUnitId: string;

  isInconsistent: boolean;

  customerTradingName: string;

  externalId: number;

  currentVersionExternalId: string;

  resultCenter: string;

  isBillingEnabled: boolean;

  billingDisabledJustificationName: string;

  billingDisabledObservation: string;

  beneficiary: string;

  countryName: string;

  countryCode: string;

  expiresAt: string;

  contractGroupName: string;

  contractPlanName: string;

  lastUpdatePlan: string;

  selected: boolean;

  pushOrderRequired: boolean;

  pushOrderExpirationDate: string;

  pushOrderNumber: string;

  isCalculationsPristine: boolean;

  createdAt: string;

  justifications: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.status = EnumObject.of(obj.status) || {};
    this.currentVersion = obj.currentVersion || '';
    this.versionDate = obj.versionDate || '';
    this.startedAt = obj.startedAt || '';
    this.concludedAt = obj.concludedAt || '';
    this.instancesAmount = obj.instancesAmount;
    this.customerName = obj.customerName || '';
    this.customerDocument = obj.customerDocument || '';
    this.businessUnitId = obj.businessUnitId || '';
    this.isInconsistent = obj.isInconsistent || false;
    this.customerTradingName = obj.customerTradingName || '';
    this.externalId = obj.externalId || 0;
    this.currentVersionExternalId = obj.currentVersionExternalId || '';
    this.resultCenter = obj.resultCenter || '';
    this.isBillingEnabled = obj.isBillingEnabled;
    this.billingDisabledJustificationName = obj.billingDisabledJustificationName || '';
    this.billingDisabledObservation = obj.billingDisabledObservation || '';
    this.beneficiary = obj.beneficiary || '';
    this.countryName = obj.countryName || '';
    this.countryCode = obj.countryCode || '';
    this.expiresAt = obj.expiresAt || '';
    this.contractGroupName = obj.contractGroupName || '';
    this.contractPlanName = obj.contractPlanName || '';
    this.lastUpdatePlan = obj.lastUpdatePlan || '';
    this.selected = obj.selected || false;
    this.pushOrderRequired = obj.pushOrderRequired || false;
    this.pushOrderExpirationDate = obj.pushOrderExpirationDate || '';
    this.pushOrderNumber = obj.pushOrderNumber || '';
    this.isCalculationsPristine = obj.isCalculationsPristine === null
      ? null
      : obj.isCalculationsPristine;
    this.createdAt = obj.createdAt || '';
    this.justifications = obj.justifications || '';
  }

  public static of(obj: any): ContractList {
    return new ContractList(obj || {});
  }

  public static ofList(obj: any[]): ContractList[] {
    return obj.map(this.of);
  }

  get billingEnabledDescription() : string {
    return this.isBillingEnabled
      ? 'Sim' : `Não - ${this.billingDisabledJustificationName}`
  }

  get inactiveStatusIcon(): object {
    return {
      icon: 'mdi-circle',
      color: 'orangePrimary',
      size: '12',
    }
  }

  get activeStatusIcon(): object {
    return {
      icon: 'mdi-circle',
      color: 'greenPrimary',
      size: '12',
    }
  }

  get inconsistentStatusIcon(): object {
    return {
      icon: 'mdi-alert',
      color: 'orangeSecondary',
      size: '18',
    }
  }

  get isInactive(): boolean {
    return this.status.value === 'INACTIVE'
  }

  get isCanceled(): boolean {
    return this.status.value === 'CANCELED'
  }

  get iconStatus(): object {
    if (this.isInactive || this.isCanceled) {
      return this.inactiveStatusIcon;
    }
    return this.isInconsistent ? this.inconsistentStatusIcon : this.activeStatusIcon;
  }
}
